import { motion } from "framer-motion";
import {
  Crown,
  Sparkles,
  BedDouble,
  Utensils,
  Car,
  Flower2,
  Lightbulb,
  Heart,
} from "lucide-react";
import { WEDDING_FEATURES } from "../data/site";

const ICONS = {
  Crown,
  Sparkles,
  BedDouble,
  Utensils,
  Car,
  Flower2,
  Lightbulb,
  Heart,
};

export default function WeddingFeatures() {
  return (
    <section
      id="wedding-features"
      data-testid="wedding-features-section"
      className="section-padding bg-beige/40 dark:bg-card relative overflow-hidden"
    >
      <div aria-hidden className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />
      <div aria-hidden className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent" />

      <div className="container-x relative">
        <div className="max-w-2xl">
          <span className="eyebrow">Venue Features</span>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-tight text-foreground">
            Everything your wedding needs,<br />
            <span className="italic text-[#7A1A24] dark:text-[#D4AF37]">already in place.</span>
          </h2>
          <p className="mt-5 text-muted-foreground">
            From the bridal room to the parking lot — a complete wedding-venue ecosystem
            built so families can host without worry.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {WEDDING_FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon] || Sparkles;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: i * 0.06, duration: 0.55 }}
                whileHover={{ y: -6 }}
                data-testid={`wedding-feature-${i}`}
                className="group relative rounded-2xl border border-border bg-card p-6 overflow-hidden hover:border-[#D4AF37]/60 transition-colors"
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-br from-[#D4AF37]/10 via-transparent to-[#7A1A24]/8 transition-opacity duration-500" />
                <div className="relative">
                  <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-[#D4AF37]/25 to-[#7A1A24]/10 text-[#7A1A24] dark:text-[#E6C555] grid place-items-center group-hover:rotate-6 group-hover:scale-110 transition-all duration-500 shadow-inner">
                    <Icon size={22} strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-5 font-display text-lg text-foreground">{f.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
